import React from 'react';
import { Scale, BookOpen, GraduationCap, Clock, TrendingUp } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { coursesData } from '../mock';
import Header from '../components/Header';
import Footer from '../components/Footer';

const iconMap = {
  'scale': Scale,
  'book': BookOpen,
  'graduation-cap': GraduationCap
};

export const CursosPage = () => {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="bg-gradient-to-b from-[#0F172A] to-[#1e293b] text-white py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-4xl md:text-6xl font-serif font-bold mb-4">
              Cursos Disponíveis
            </h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Aprimore seus conhecimentos com nossos cursos especializados em Direito
            </p>
          </div>
        </section>

        {/* Courses Grid */}
        <section className="py-16 md:py-20">
          <div className="max-w-7xl mx-auto px-6">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {coursesData.map((course) => {
                const IconComponent = iconMap[course.icon];
                return (
                  <Card key={course.id} className="overflow-hidden hover:shadow-xl transition-all duration-300 border-0 hover:scale-105">
                    {/* Icon Container */}
                    <div className="h-48 bg-[#e2e8f0] flex items-center justify-center">
                      <IconComponent size={64} className="text-[#B49163]" />
                    </div>
                    <CardContent className="p-6 bg-white">
                      <h3 className="text-2xl font-serif font-semibold text-[#0F172A] mb-3">
                        {course.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed mb-4">
                        {course.description}
                      </p>
                      
                      <div className="flex items-center gap-4 mb-4 text-sm text-gray-500">
                        <div className="flex items-center gap-1">
                          <Clock size={16} />
                          <span>{course.duration}</span>
                        </div>
                        <div className="flex items-center gap-1">
                          <TrendingUp size={16} />
                          <span>{course.level}</span>
                        </div>
                      </div>
                      
                      <Button 
                        className="w-full bg-[#0F172A] hover:bg-[#1e293b] text-white py-3 rounded-lg transition-colors duration-300"
                      >
                        Saiba Mais
                      </Button>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default CursosPage;